import { createHttpClient } from "../utils/http-client";

export const authClient = createHttpClient({
    baseUrl: import.meta.env.VITE_AUTH_URL
});